<template>
	<div class="card mb-2">
		<div class="card-header">
			<span class="text-left">
				Számlázási azonosítók
			</span>
		</div>
		<div class="card-body">
			<div class="row d-flex">
				<div class="col-12 col-sm-6 col-md-4 col-lg-3">
					<div class="mui-textfield mui-textfield">
				    	<input type="text" v-model="maverix_id">
				    	<label>Maverix azonosító</label>
					</div>
				</div>
				<div class="col-12 col-sm-6 col-md-4 col-lg-3">
					<button
						class="btn btn-primary"
						@click.prevent="saveMaverix"
					>
						Mentés
					</button>
				</div>
			</div>
				
			<div class="table-responsive">
				<table class="table table-striped">
					<thead>
						<th>Szolgáltató</th>
						<th>Billingo ID</th>
						<th>Művelet</th>
					</thead>
					<tbody>
						<tr
							v-for="(v,k) in szolg"
							:key="k"
						>
							<td>{{ v.nev }} - {{ v.megjegyzes }}</td>
							<td
							>
								<span v-if="v.billingo_id">
									{{ v.billingo_id }}		
								</span>
								<button
									class="btn btn-warning"
									v-else
									@click.prevent="showSetBillingoID(v)"
								>
									Megadom az azonosítót
								</button>
							</td>
							<td>
								<button
									class="btn btn-primary"
									v-if="!v.billingo_id"
									@click.prevent="insert(v)"
								>
									Létrehozás
								</button>
								<button
									class="btn btn-success"
									v-else
									@click.prevent="update(k)"
									disabled
								>
									Frissít
								</button>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
		<div
			class="modal fade"
			id="addbillingoid"
		>
			<div class="modal-dialog">
				<div class="modal-content">
	  				<div class="modal-body">
	    				<div class="mui-textfield mui-textfield--float-label">
					    	<input
					    		type="text"
					    		v-model="billingo_id"
					    	>
					    	<label>Ügyfél Billingo azonosítója</label>
					  	</div>
	  				</div>
	  					<div class="modal-footer">
	    				<button
	    					type="button"
	    					class="btn btn-secondary"
	    					@click.prevent="close"
	    				>
	    					Mégsem
	    				</button>
	    				<button
	    					type="button"
	    					class="btn btn-primary"
	    					@click.prevent="save"
	    				>
	    					Mentés
	    				</button>
	  				</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script type="text/javascript">
export default {
	props: ['customer'],

	data() {
		return {
			szolg: [],
			billingo_id: null,
			maverix_id: null,
			szla_szolg: null
		}
	},

	created() {
		this.init()
	},

	methods: {
		init() {
			this.$Progress.start()
			this.req.get('/customers/billingo/idlist/' + this.customer.uszam)
				.then(res => {
					this.szolg = res.data.szolg
					this.$Progress.finish()
				})
				.catch(err => {
					console.error(err)
					toastr.error(err)
	    			this.$Progress.fail()
				})
			this.$Progress.start()
			this.req.get('/customers/maverix/id/' + this.customer.uszam)
				.then(res => {
					this.maverix_id = res.data.id || null
					this.$Progress.finish()
				})
				.catch(err => {
					console.error(err)
					toastr.error(err)
	    			this.$Progress.fail()
				})
		},
		
		showSetBillingoID(szolg) {
			this.szla_szolg = szolg.id
			$('#addbillingoid').modal('show')
		},

		close() {
			this.billingo_id = null
        	$('#addbillingoid').modal('hide')
		},

		saveMaverix() {
			this.$Progress.start()
			this.req.post('/customers/maverix/id', {
				uszam: this.customer.uszam,
				maverix_id: this.maverix_id
			})
				.then(res=>{
					this.$Progress.finish()
					toastr.success('Mentés ok')
    				this.init()
    			})
    			.catch(err=>{
    				console.error(err)
    				this.$toast.error(err.response.data.text || err)
    				this.$Progress.fail()
    			})
		},

		save() {
			this.$Progress.start()
			this.req.post('/customers/billingo/insertID', {
    			uszam: this.customer.uszam,
    			szla_szolg: this.szla_szolg,
    			billingo_id: this.billingo_id
    		})
    			.then(res=>{
    				$('#addbillingoid').modal('hide')
    				this.szla_szolg = null
    				this.billingo_id = null
    				this.init()
    			})
    			.catch(err=>{
    				console.error(err)
    				this.$toast.error(err.response.data.text || err)
    				this.$Progress.fail()
    			})
		},

		insert(szolg) {
			this.$Progress.start()
			this.req.post('/customers/billingo/insert', {
    			customer: this.customer,
    			szla_szolg: szolg.id
    		})
    			.then(res=>{
    				this.init()
    			})
    			.catch(err=>{
    				console.error(err)
    				this.$toast.error(err.response.data.text || err)
    				this.$Progress.fail()
    			})
		},

		update() {

		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/customers/customer_billingo.vue